import { Component, Mixins } from 'vue-property-decorator'

import WindowResizeMixin from '../../logic/helpers/WindowResizeMixin'
import { ActiveBotLicenseSteps, FlowTemplate } from './types'

@Component
export default class FlowsTemplatesMixin extends Mixins<WindowResizeMixin>(WindowResizeMixin) {
  currentStep = ActiveBotLicenseSteps.Start

  selectedTemplate: FlowTemplate | null = null

  get modalWidth(): string {
    if (this.windowWidth < 576) {
      return '95%'
    }

    if (this.windowWidth < 1050 && this.windowWidth > 576) {
      return '85%'
    }

    return '992px'
  }

  resetWizard() {
    this.currentStep = ActiveBotLicenseSteps.Start
    this.selectedTemplate = null
  }

  updateStep(step: null | ActiveBotLicenseSteps) {
    if (!step) {
      this.resetWizard()
    } else {
      this.currentStep = step
    }
  }
}
